import { render, staticRenderFns } from "./DemoArticle.vue?vue&type=template&id=08400712&"
import script from "./DemoArticle.vue?vue&type=script&lang=js&"
export * from "./DemoArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports